import { css, styled } from '@mui/material/styles';

import { Box, Button as Btn } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: overlay;
  background: #f5f5f5;
  padding: 42px 30px;
`;

export const Header = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  align-items: center;

  .css-1d3z3hw-MuiOutlinedInput-notchedOutline {
    border-style: 'hidden';
  }

  .btn-back {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 22px 6px 16px;
    gap: 8px;
    width: 125px;
    height: 48px;
    border: 1px solid #212121;
    border-radius: 4px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
    letter-spacing: 0.5px;
    color: #212121;
  }
`;

export const SectionBoard = styled(Box)`
  padding: 30px;
  background: #ffffff;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  display: flex;
  // height: 50vh;
  align-items: start;
  overflow-y: overlay;

  .title-files-boards {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Page = styled(Box)`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const BallStatus = styled(Box)`
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #e31b0c;
`;

export const Buttons = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;

  .btn-csv {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px 10px;
    height: 24px;
    background: ${({ theme }) => theme.palette.primary.main};
    border-radius: 32px;
    text-decoration: none;
    color: ${({ theme }) => theme.palette.common.white};
    font-size: 13px;
    font-weight: 500;
    transition: 0.2s background-color;

    &:hover {
      background: ${({ theme }) => theme.palette.primary.dark};
    }
  }
`;

export const ButtonSave = styled(Btn)`
  background: #4caf50;
  width: 131px;
  height: 24px;
  border-radius: 32px;
  text-transform: capitalize;
  white-space: nowrap;
`;

export const ButtonCancel = styled(Btn)`
  height: 24px;
  border-radius: 32px;
  text-transform: capitalize;
  white-space: nowrap;
`;

export const SectionMember = styled(Box)`
  padding: 20px;

  width: 100%;
  border: 1px solid #12094d;
  border-radius: 6px;
  padding: 20px;

  &.disabled {
    background: ${({ theme }) => theme.palette.grey[400]};
    cursor: not-allowed;

    button {
      border-radius: 32px;
      height: 24px;
      color: ${({ theme }) => theme.palette.common.white};
      text-transform: capitalize;
      background-color: ${({ theme }) => theme.palette.grey.A100};
    }
  }
`;

export const SectionHeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Typography = styled(Box)``;

export const Div = styled(Box)`
  .title-board {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 34px;
    line-height: 42px;
    display: flex;
    align-items: start;
    text-align: start;
    letter-spacing: 0.25px;
  }
  .title-select {
    font-family: 'Roboto';
    font-style: normal;
    font-size: 15px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #0b79d0;
  }
  .text-board {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.15px;
    color: #323232;
  }

  .title-members {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #212121;
  }

  .header-table {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const TabSelection = styled(Box)`
  display: flex;
  flex-direction: row;
  background: #ffffff;
  border-radius: 4px;
  Button {
    width: 160px;
    height: 48px;
    padding: 17px 43px;
    border-radius: 0;
  }
`;

interface ButtonProps {
  active: boolean;
}

export const TabButton = styled(Btn)`
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  ${(props: ButtonProps) =>
    props.active &&
    css`
      font-weight: 800;
      border-bottom: 2px solid #206da7;
      color: #206da7;
    `}
`;

export const Card = styled(Box)`
  margin-top: 20px;
  padding: 10px;
  height: 90px;
  background: #ffffff;
  border: 1px solid #bdbdbd;
  border-radius: 6px;

  .meeting-data {
    border-right: 1px solid #d0d0d0;
    width: 114px;
    height: 70px;
  }

  .data {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 23px;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: ${({ theme }) => theme.palette.primary.main};
  }

  .duration {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #9e9e9e;
  }

  .status {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.15px;
    color: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2px 8px;
    width: 117px;
    height: 24px;
    border-radius: 50px;
  }

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.1px;
    color: #000000;
  }
`;

export const FileCard = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 15px;
  gap: 10px;
  width: 490px;
  height: 60px;
  border: 1px solid #bdbdbd;
  border-radius: 6px;
  width: 100%;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #424242;
`;
export const Text = styled(Box)``;

export const ContainerUsers = styled(TableContainer)`
  overflow-y: auto;
  height: 53vh;

  @media (max-height: 871px) {
    height: 43vh;
  }

  @media (max-height: 735px) {
    height: 40vh;
  }

  @media (max-height: 692px) {
    height: 35vh;
  }

  @media (max-height: 636px) {
    height: 30vh;
  }

  @media (max-height: 589px) {
    height: 25vh;
  }

  @media (max-height: 554px) {
    height: 20vh;
  }
`;
